import { selector } from 'recoil';

import {
  statementsFilterParamsState,
  statementOptionQueryState,
  isExportingPdfForStatements,
} from '../atom';
import { StatementOptionQuery, StatementsFilterParamsProps } from '../types';

export const updateStatementOptionSelector = selector({
  key: 'updateStatementOptionSelector',
  set: ({ set }, value) => {
    set(statementOptionQueryState, value as StatementOptionQuery);
  },
  get: ({ get }) => {
    const params = get(statementOptionQueryState);
    return params;
  },
});

export const updateStatementsFilterParamsSelector = selector({
  key: 'updateStatementsFilterParamsSelector',
  set: ({ set, get }, value) => {
    const currentParams = get(statementsFilterParamsState);
    const data = value as StatementsFilterParamsProps;

    const params = { ...currentParams, ...data } as StatementsFilterParamsProps;
    set(statementsFilterParamsState, params);
  },
  get: ({ get }) => {
    const params = get(statementsFilterParamsState);
    return params;
  },
});

export const updateIsExportingPdfForStatements = selector({
  key: 'updateIsExportingPdfForStatements',
  set: ({ set }, newValue) => {
    const isExporting = newValue as boolean;
    return set(isExportingPdfForStatements, isExporting);
  },
  get: ({ get }) => {
    const item = get(isExportingPdfForStatements);
    return item;
  },
});

export * from './currentAccount';
export * from './directTreasury';
export * from './fixedIncome';
export * from './fund';
export * from './pension';
